import { render } from "./TeacherStudentUserManageView.vue?vue&type=template&id=40b47c3c&scoped=true"
import script from "./TeacherStudentUserManageView.vue?vue&type=script&lang=js"
export * from "./TeacherStudentUserManageView.vue?vue&type=script&lang=js"

import "./TeacherStudentUserManageView.vue?vue&type=style&index=0&id=40b47c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b47c3c"]])

export default __exports__